"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function randomPick(array) {
    return array[Math.floor(Math.random() * array.length)];
}
exports.randomPick = randomPick;
function randomString(possible, length) {
    var text = "";
    for (var i = 0; i < length; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
}
exports.randomString = randomString;
function randomDigitString(length) {
    return randomString("0123456789", length);
}
exports.randomDigitString = randomDigitString;
function getNumberFixedLength(number, length) {
    var str = number.toString();
    while (str.length < length) {
        str = '0' + str;
    }
    return str;
}
exports.getNumberFixedLength = getNumberFixedLength;



//////////////////
// WEBPACK FOOTER
// ../dist/commonjs/utils.js
// module id = 249
// module chunks = 0